export default {"src":"/kelp/_next/static/media/ethx.67eed7ab.svg","height":20,"width":20,"blurWidth":0,"blurHeight":0};